import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./CheckListElementCard.module.css";
import { AppChecklist } from "../../types/AppChecklist";

interface Props {
    appChecklist: AppChecklist;
}

export default function AppChecklistCard({ appChecklist }: Props) {
    const { t } = useTranslation("common");

    const submittedDate = appChecklist.submittedAt
        ? new Date(appChecklist.submittedAt).toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' })
        : null;

    return (
        <div className={styles.checklistCard} data-cy="AppChecklistCard">
            <div className={styles.checklistHeader}>
                <div className={styles.checklistCardTitle}>
                    {t('appChecklist.availableInAppBold')}
                </div>
                <div className={styles.checklistCardRequired}>
                    <span className={appChecklist.status === 'submitted' ? styles.submittedPill : styles.notSubmittedPill}>
                        {appChecklist.status === 'submitted' ? t('appChecklist.submitted') : t('appChecklist.notSubmitted')}
                    </span>
                </div>
            </div>
            <div className={styles.checklistCardBody}>
                <div className={styles.appChecklistBody}>
                    {submittedDate && (
                        <p className={styles.submittedDate}>{t('appChecklist.submittedOn', { date: submittedDate })}</p>
                    )}
                    <p>{t('appChecklist.availableInApp')} <strong>{t('appChecklist.availableInAppBold')}</strong>.</p>
                    <p>{t('appChecklist.useAppToComplete')}</p>
                    <div className={styles.appChecklistMeta}>
                        <span>{appChecklist.checklistType}</span>
                        <span>v{appChecklist.version}</span>
                    </div>
                </div>
            </div>
            <div className={styles.checklistCardFooter} />
        </div>
    );
}
